import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {

  private _subject: Subject<any>;
  observer: Observable<any>;

  className = 'SpinnerService';

  constructor() {
    this._subject = new Subject<any>();
    this.observer = this._subject.asObservable()
  }

  loading(data) {      
    this._subject.next(data);
  }
}
